var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loaderContainer",class:_vm.loaderType,style:(!_vm.show ? 'display:none;' : '')},[_c('p',[_vm._v(_vm._s(_vm.loaderMessage))]),_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }